module.exports = __webpack_public_path__ + "static/media/instruments-spanish.5f0225cf.png";